import { Badge, Button } from '@predoc/cow';
import { ArrowLeft } from 'lucide-react';
import { TruncatedText } from '@/components';
import type { FacesheetCriteriaRow } from './types';

interface FacesheetQuestionRowProps {
  criteriaRow: FacesheetCriteriaRow;
  onBack?: () => void;
}

export const FacesheetQuestionRow = ({
  criteriaRow,
  onBack,
}: FacesheetQuestionRowProps) => {
  return (
    <div className="border-border bg-background border-b px-4 pt-1.5 pb-4">
      <div className="flex items-start gap-2">
        {onBack ? (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onBack}
            aria-label="Back to facesheet"
            className="mt-1 size-9 shrink-0"
          >
            <ArrowLeft className="size-5" />
          </Button>
        ) : null}

        <div className="border-border min-w-0 flex-1 overflow-hidden rounded-md border">
          <table className="w-full table-fixed border-collapse text-sm">
            <thead>
              <tr className="border-border border-b">
                <th
                  scope="col"
                  className="text-muted-foreground px-4 py-2 text-left font-medium"
                >
                  Question
                </th>
                <th
                  scope="col"
                  className="text-muted-foreground w-[273px] px-4 py-2 text-left font-medium"
                >
                  Answer
                </th>
                <th
                  scope="col"
                  className="text-muted-foreground px-4 py-2 text-left font-medium"
                >
                  Reason
                </th>
                <th
                  scope="col"
                  className="text-muted-foreground w-32 px-4 py-2 text-left font-medium"
                >
                  References
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-foreground min-h-12 px-4 py-3.5 align-top">
                  {criteriaRow.question}
                </td>
                <td className="text-foreground px-4 py-3.5 align-top">
                  <TruncatedText text={criteriaRow.answer} />
                </td>
                <td className="text-foreground px-4 py-3.5 align-top">
                  {criteriaRow.reason}
                </td>
                <td className="px-4 py-3 align-top">
                  <Badge className="bg-muted text-foreground">Viewing</Badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
